export { default } from "@casino/shared/utils/isWebComponentGame";
